'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowRight20Filled, DismissFilled, CheckmarkStarburst24Regular, Checkmark20Filled } from '@fluentui/react-icons';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Typography, useTheme } from '@mui/material';
import { useState } from 'react';
import SSearchInput from '@ui/components/common/SSearchInput';
const SelectProjectDialog = ({ isOpen, projects = [], onClose, onSelectProject, setRefresh }) => {
    const theme = useTheme();
    const [searchQuery, setSearchQuery] = useState('');
    const [fullAccess, setFullAccess] = useState(true);
    const handleClose = () => {
        onClose();
    };
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };
    const handleSelectProject = (projectId) => {
        onSelectProject(projectId);
    };
    const toggleFullAccess = () => {
        setFullAccess(!fullAccess);
    };
    const filteredProjects = projects.filter((project) => project.name.toLowerCase().includes(searchQuery.toLowerCase()));
    return (_jsxs(Dialog, { open: isOpen, onClose: handleClose, maxWidth: 'sm', PaperProps: {
            sx: {
                width: '564px'
            }
        }, fullWidth: true, children: [_jsxs(DialogTitle, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }, children: [_jsx(Typography, { variant: 'h6', color: 'text.primary', children: "Select Project" }), _jsx(IconButton, { onClick: handleClose, children: _jsx(DismissFilled, { fontSize: 18 }) })] }), _jsx(Divider, {}), _jsx(DialogContent, { children: _jsxs(Box, { display: 'flex', flexDirection: 'column', gap: 2, mt: 1, children: [_jsx(Box, { sx: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }, children: _jsx(SSearchInput, { onChange: handleSearch }) }), _jsx(Box, { sx: { overflowY: 'auto', maxHeight: '300px' }, children: filteredProjects.map((project) => (_jsxs(Box, { sx: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    padding: '12px',
                                    borderRadius: 1,
                                    bgcolor: theme.palette.background.neutral,
                                    mb: 1,
                                    cursor: 'pointer',
                                    '&:hover': {
                                        bgcolor: theme.palette.action.hover
                                    }
                                }, onClick: () => handleSelectProject(project.id), children: [_jsxs(Box, { display: 'flex', gap: 0.5, alignItems: 'center', children: [_jsx("img", { src: project.icon || '/placeholder.svg', alt: project.name, height: '24px', width: '22px' }), _jsx(Typography, { variant: 'body1', children: project.name })] }), _jsx(IconButton, { children: _jsx(ArrowRight20Filled, {}) })] }, project.id))) }), _jsxs(Box, { onClick: toggleFullAccess, sx: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                padding: '12px',
                                borderRadius: 1,
                                bgcolor: 'rgba(142, 51, 255, 0.12)',
                                cursor: 'pointer',
                                mt: 1
                            }, children: [_jsxs(Box, { display: 'flex', gap: 0.5, alignItems: 'center', children: [_jsx(CheckmarkStarburst24Regular, { style: { color: 'rgba(81, 25, 183, 1)' } }), _jsx(Typography, { variant: 'body1', sx: { color: theme.palette.primary.dark }, children: "Full Access" })] }), fullAccess && _jsx(Checkmark20Filled, { style: { color: 'rgba(81, 25, 183, 1)' } })] })] }) }), _jsx(Divider, {}), _jsx(DialogActions, { sx: { p: 3 } })] }));
};
export default SelectProjectDialog;
